<template>
  <v-card
    width="220px"

    class="mx-4 restaurant-card">
    <v-img height="170px" v-bind:src="restaurant.pictures[0]"></v-img>
    <v-card-title
      id="card-title" align="left">
      {{ restaurant.name }}
    </v-card-title>
    <v-rating
      class="ml-5"
      :value="restaurant.rating"
      color="warning"
      dense
      background-color="warning lighten-1"
      half-increments
      readonly
      size="14"
    ></v-rating>
    <v-card-actions>
      <v-btn
        class="ml-4"
        text
        outlined
        background-colorcolor="accent"
      >
        <router-link

          style="text-decoration: none; color: inherit;"
          :to="{
          name: 'Restaurant',
          params: {
            userId: '604cc220ef6fa10004dc0179',
            restaurant: restaurant
            }
          }"
        >More info </router-link>
      </v-btn>
    </v-card-actions>

  </v-card>
</template>

<script>
export default {
  name: "restaurant-card-suggestion",
  components: {
  },
  props: ['restaurants','restaurant'],
  data: () => ({
    modalVisible : false,
    userid : '604cc220ef6fa10004dc0179'
  }),
  async created () {

  },

}
</script>

<style scoped>

</style>
